import { Box } from '@mui/material'
import React from 'react'
import { useGroupForProduct } from '../../../../api/tree.hooks'

export function ProductGroupDisplay<T extends { id: number }>({
  item: { id },
}: {
  item: T
}) {
  const group = useGroupForProduct(id)
  if (!group) return <Box />
  return <Box>{`${group.id}: ${group.name}`}</Box>
}
